import axios from "axios";

class AuthService {
    login(formData) {
        return axios.post('auth/login/', {
            keyId_sign: formData.keyId_sign,
            alias_sign: formData.alias_sign,
            algorithm_sign: formData.algorithm_sign,
            subjectCn_sign: formData.subjectCn_sign,
            subjectDn_sign: formData.subjectDn_sign,
            issuerCn_sign: formData.issuerCn_sign,
            issuerDn_sign: formData.issuerDn_sign,
            serialNumber_sign: formData.serialNumber_sign,
            certNotAfter_sign: formData.certNotAfter_sign,
            certNotBefore_sign: formData.certNotBefore_sign,
            authorityKeyIdentifier_sign: formData.authorityKeyIdentifier_sign,
            pem_sign: formData.pem_sign,
        });
    }

    loginWithIin(formData) {
        return axios.post('auth/login_iin/', {
            username: formData.username,
            password: formData.password
        })
    }

    activateUser(formData) {
        return axios.post('auth/activate_user/', {
            password: formData.password,
            email: formData.email
        });
    }

    changePassword(formData) {
        return axios.post('auth/change_password/', {
            // old_password: formData.old_password,
            new_password: formData.new_password
        });
    }

}

export default new AuthService()